const LOGO_WHITE =
  "https://customer-assets.emergentagent.com/job_superate-aprende/artifacts/cdomqh2d_LogoVectorBlanco_2.0.svg";

const footerLinks = [
  { label: "Inicio", href: "#inicio" },
  { label: "Cursos", href: "#cursos" },
  { label: "Cómo funciona", href: "#como-funciona" },
  { label: "Modalidades", href: "#modalidades" },
  { label: "Contacto", href: "#contacto" },
];

export default function Footer() {
  const handleClick = (e, href) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer data-testid="footer" className="border-t border-white/5">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-12 lg:py-16">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          {/* Logo */}
          <div>
            <img
              src={LOGO_WHITE}
              alt="Supérate"
              data-testid="footer-logo"
              className="h-8 w-auto mb-4"
            />
            <p className="text-sm text-[#71717a] max-w-xs">
              Apoyo universitario con material de calidad. Clases particulares y
              cursos para rendir mejor.
            </p>
          </div>

          {/* Links */}
          <nav className="flex flex-wrap gap-x-8 gap-y-3">
            {footerLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => handleClick(e, link.href)}
                className="text-sm text-[#71717a] hover:text-white transition-colors"
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>

        <div className="mt-12 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-[#52525b]">
            &copy; {new Date().getFullYear()} Supérate. Todos los derechos
            reservados.
          </p>
          <p className="text-xs text-[#52525b]">
            Diseñado para estudiantes que quieren más.
          </p>
        </div>
      </div>
    </footer>
  );
}
